module.exports = __webpack_public_path__ + "img/CookiesBIS.52515891.svg";